import { domainMap } from 'config/env'
import { v4 } from 'uuid'

import { VISITOR_ID_KEY } from 'app-constants'

const cookieExists = () =>
  document.cookie.split(';').filter(item => item.trim().includes(`${VISITOR_ID_KEY}=`)).length

export const cookieValue = () =>
  document.cookie
    .split(';')
    .filter(cookie => cookie.includes(`${VISITOR_ID_KEY}`))
    .toString()
    .split('=')
    .pop()

export const setVisitorId = () => {
  let id
  if (cookieExists()) {
    id = cookieValue()
  } else {
    id = v4()
    document.cookie = `${VISITOR_ID_KEY}=${id}; domain=${domainMap.get(
      process.env.BUILD_ENV,
    )}; path=/ `
  }
  return id
}

export default { setVisitorId }
